import { List } from 'immutable';
import React from 'react';
import shallowCompare from '../../../lib/shallowCompare';
import OrderItemTile from '../../OrderItemTile';
import styles from './index.sass';

class OrderSummaryDropdown extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  static propTypes = {
    shoppingCart: React.PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      orderSummaryOpen: false
    };
  }

  getStateFromProps(props) {
    return {
      customer                    : props.customer,
      customerError               : props.customerError,
      shoppingCart                : props.shoppingCart,
      shoppingCartError           : props.shoppingCartError,
      shoppingCartRequestStatus   : props.shoppingCartRequestStatus
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickOpenOrderSummaryButton(e) {
    this.setState({orderSummaryOpen: !this.state.orderSummaryOpen});
  }

  renderItems(shoppingCart) {
    return shoppingCart.items.map(orderItem => {
      return <OrderItemTile orderItem={orderItem} key={orderItem.id} />;
    });
  }

  render() {
    let { shoppingCart } = this.props;
    if(!shoppingCart || !shoppingCart.items.size) {return null;}

    return (
      <div className={`${styles.orderSummary} ${this.state.orderSummaryOpen ? styles.open : styles.closed}`}>
        <button onClick={this.handleOnClickOpenOrderSummaryButton.bind(this)}>Order summary</button>
        <div className={styles.orderItems}>
          {this.renderItems(shoppingCart)}
        </div>
      </div>
    );
  }
}

export default OrderSummaryDropdown;



// WEBPACK FOOTER //
// banquet/components/Checkout/OrderSummary/index.js